import React, { Component } from 'react';
import classNames from 'classnames';
import 'styles/IntroPage.css';
const { TimelineMax, Sine } = window
var ga = window.ga;

class PortfolioSlide extends Component {
	constructor(props) {
		super(props);

	}

  componentDidMount() {
    ga('send', 'event', 'Portfolio: ' + this.props.title, 'Slide View', this.props.slide.title);
  }

  componentWillEnter(callback) {
    // console.log('pagecontainer will enter', this.props.tester);
    this.animateIn(callback);
  }

  componentDidEnter(){
    // console.log('pagecontainer did enter', this.props.tester);
    this.props.pageTransitionFinish();
  }


  componentWillLeave(callback) {
    // console.log('pagecontainer will leave', this.props.tester);
    this.animateOut(callback);
    // callback();
  }

  componentDidLeave(){
    // console.log('pagecontainer did leave', this.props.tester);
  }

  // renderRoles() {
  //   return this.props.slide.role.map((role, i) => {
  //     return (
  //       <span>{role}</span>
  //     )
  //   });
  // }

  render() {
    let { slide } = this.props
    // console.log(slide);
    let style = {
      "backgroundImage": "url(" + slide.projectImage + ")"
    }
    // let roles = this.renderRoles()
    return (
      <div className="slide"  style={style} ref={(el) => this.el = el}>
        <div className="content-box" ref={(el) => this.content = el}>
          <h2>{slide.projectType}</h2>
          <h1>{slide.title}</h1>

          {slide.projectRole !== '' ? 
            <div>
              <h2>Role</h2>
              <h1>{slide.projectRole}</h1>
            </div>
          : null }


          {slide.projectTimeline !== '' ? 
            <div>
              <h2>Timeline</h2>
              <h1>{slide.projectTimeline}</h1>
            </div>
          : null }

          {slide.projecturl !== '' &&  slide.projectCta !== '' ? 
            <a href={slide.projecturl} target="_blank"><div className="linkout-btn">{slide.projectCta}</div></a>
          : null }


        </div>
      </div>
    )
  }

  animateIn(callback){
    let { dir } = this.props
    var tween = new TimelineMax({onComplete: callback})
    let { el, content } = this

    tween
    .set(el, {x: 100*dir + '%', "zIndex": 2})
    .set(content, {x: 100*dir + '%'})
    .to(el, .96, {
      x: '0%',
      ease: window.Sine.easeOut
    })
    .to(content, .96, {
      x: '0%',
      ease: window.Sine.easeOut
    }, 0)
  }

  animateOut(callback){
    let { dir } = this.props
    var tween = new TimelineMax({onComplete: callback})
    let { el, content } = this

    tween
    .set(el, {"zIndex": 1})
    .to(el, .96, {
      x: -50*dir + '%',
      ease: window.Sine.easeOut
    })
    .to(content, .96, {
      x: -100*dir + '%',
      ease: window.Sine.easeIn
    }, 0)
  }
}

export default PortfolioSlide;



// WEBPACK FOOTER //
// ./src/scripts/components/portfolioSlide.js